/* eslint-disable */
export const ZoomWorkplaceRebrandingReg = /Zoom\s*One/gi;
export const ZOOM_WORKPLACE = 'Zoom Workplace';
export const zoomSessionsRebrandingReg = /Zoom\s*Sessions?/gi;
export const ZOOM_WEBINARS_PLUS = 'Zoom Webinars Plus';

export function translation4Rebranding(originalFn, isRebranding) {
  if (isRebranding) {
    return (...args) => {
      const text = originalFn(...args);
      return text.replace(ZoomWorkplaceRebrandingReg, ZOOM_WORKPLACE);
    };
  }
  return originalFn;
}

export function dynamicTranslation4Rebranding(originalFn, rebrandingConfig = {}) {
  const { isZoomWorkplaceRebranding, sessionToWebinarPlusRename } = rebrandingConfig;
  const isRebranding = isZoomWorkplaceRebranding || sessionToWebinarPlusRename;
  if (isRebranding) {
    return (...args) => {
      let text = originalFn(...args);
      if (isZoomWorkplaceRebranding) {
        text = text.replace(ZoomWorkplaceRebrandingReg, ZOOM_WORKPLACE);
      }
      if (sessionToWebinarPlusRename) {
        text = text.replace(zoomSessionsRebrandingReg, ZOOM_WEBINARS_PLUS);
      }
      return text;
    };
  }
  return originalFn;
}

export const getRebrandingPayload = (payload) => {
  const result = {};
  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    if (typeof value === 'string' && ZoomWorkplaceRebrandingReg.test(value)) {
      result[key] = value.replace(ZoomWorkplaceRebrandingReg, ZOOM_WORKPLACE);
    } else {
      result[key] = value;
    }
  });
  return result;
};

export const dataLayer4Rebranding = (originalFn, isRebranding) => {
  if (isRebranding) {
    return function () {
      if (arguments[0] && typeof arguments[0] === 'object') {
        arguments[0] = getRebrandingPayload(arguments[0]);
      }
      originalFn.apply(this, arguments);
    };
  }
  return originalFn;
};

export const traverseObj = (payload) => {
  for (let key in payload) {
    if (payload.hasOwnProperty(key)) {
      const value = payload[key];
      if (typeof value === 'object' && value !== null) {
        if (value instanceof Date || value instanceof RegExp || value instanceof Map || value instanceof Set) {
          continue;
        } else {
          traverseObj(payload[key]);
        }
      } else {
        if (typeof value === 'string') {
          // console.log('%c Billing-rebranding: ', 'background: black; color: white; line-height: 20px; border-radius: 4px', key, value);
          if (ZoomWorkplaceRebrandingReg.test(value)) {
            payload[key] = value.replace(ZoomWorkplaceRebrandingReg, ZOOM_WORKPLACE);
          }
          if (isSessionsToWebinarPlusRename() && zoomSessionsRebrandingReg.test(value)) {
            payload[key] = value.replace(zoomSessionsRebrandingReg, ZOOM_WEBINARS_PLUS);
          }
        } else {
          payload[key] = value;
        }
      }
    }
  }
}

export const dataLayerPayload4Rebranding = (payload) => {
  try {
    traverseObj(payload);
    return payload;
  } catch {
    return payload;
  }
}

function isSessionsToWebinarPlusRename () {
  return window.newBillingConfig && window.newBillingConfig.sessionToWebinarPlusRename;
}
